/**
 * CRA/webpack-safe build-time environment access.
 *
 * webpack's DefinePlugin replaces the literal token `process.env` with an
 * inlined object at build, so `process.env[name]` resolves BOTH in the browser
 * bundle and in Node/jsdom tests. Do NOT reintroduce the previous pattern:
 *
 *     const env = (typeof process !== "undefined" && process.env) || {};
 *
 * In the webpack-5 browser bundle bare `process` is undefined, so that guard is
 * false and `env` becomes `{}` — every configured REACT_APP_* value then
 * silently falls back to its default even when set at build time. That defect
 * broke the feature flags (G1) and the runtime config (this P0). Referencing
 * `process.env.<NAME>` / `process.env[name]` directly is what DefinePlugin
 * inlines, so it is the only correct pattern here.
 */

/** Read a build-time env var, or `fallback` when unset/empty-undefined. */
export function readEnv(name, fallback = undefined) {
  try {
    const v = process.env[name];
    return v === undefined ? fallback : v;
  } catch {
    return fallback;
  }
}

/** Coerce a build-time env var to boolean with a safe default. */
export function readBool(name, def = false) {
  const v = readEnv(name);
  return v === undefined || v === "" ? def : /^(1|true|yes|on)$/i.test(String(v));
}

/**
 * True when the env token was actually inlined (NODE_ENV is always defined by
 * CRA). If this is false in a built browser bundle, DefinePlugin did not run and
 * configuration would silently use fallbacks only — callers can assert on it.
 */
export const ENV_RESOLVED = readEnv("NODE_ENV") !== undefined;
